import { PlusOutlined } from "@ant-design/icons";
import {
  Form,
  Input,
  InputNumber,
  Button,
  DatePicker,
  Upload,
  message,
  Select,
  Row,
  Col,
} from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useBasePath } from "../../../components/NavigatePath";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import axios from "axios";
import UploadProfilePicture from "../../../components/UploadProfilePicture";

function AddMedicines() {
  const user = useSelector((state) => state.user.user);
  const userType = Number(user.roleDetails.id);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const basePath = useBasePath();
  const accessToken = useSelector((state) => state.user.accessToken);
  const API_URL = import.meta.env.VITE_API_URL;
  const { TextArea } = Input;
  const [imageUrl, setImageUrl] = useState("");

  const handleSubmit = async (values) => {
    console.log(values);
    const supplierContact = String(values.supplierContact);
    if (imageUrl == "" || null) {
      return message.error("Please upload an image");
    }
    const payload = {
      ...values,
      supplierContact: supplierContact,
      expiryDate: values.expiryDate.toISOString(),
      image: imageUrl,
      dose: values.dose,
    };
    try {
      const response = await axios.post(`${API_URL}Medicines`, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      console.log(response);
      message.success("Medicine added successfully.");
      navigate(`/${basePath}/medicines`);
    } catch (error) {
      message.destroy();
      console.error("Error adding medicine:", error);
      console.error(error?.response?.data.message);
      message.error(`Failed to add medicine. ${error?.response?.data.message}`);
    }
    // message.destroy();
  };

  const handleCancel = () => {
    form.resetFields();
    navigate(-1);
  };

  return (
    <div className="p-4 md:p-6 lg:p-8">
      <h1 className="text-xl md:text-2xl font-bold mb-4 md:mb-6">Add New Medicine</h1>

      <div className="bg-white p-4 md:p-6 lg:p-8 rounded-sm">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          style={{ width: "100%" }}
          disabled={userType !== 1}
        >
          <Row gutter={[24, 16]}>
            {/* Left Column for Image */}
            <Col xs={24} sm={24} md={6} className="flex flex-col items-center mb-6 md:mb-0">
              <div className="w-full max-w-[200px]">
                <UploadProfilePicture
                  onChange={(url) => {
                    setImageUrl(url);
                  }}
                  value={imageUrl}
                />
                <p className="text-center mt-2 text-gray-500">Medicine Image</p>
              </div>
            </Col>

            {/* Right Column for Form */}
            <Col xs={24} sm={24} md={18}>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Name (En)"
                    name="name"
                    rules={[
                      { required: true, message: "Please enter a name" },
                    ]}
                  >
                    <Input placeholder="Enter name" className="h-10" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Name (AR)"
                    name="name_ar"
                    rules={[
                      { required: true, message: "Please enter a name" },
                    ]}
                  >
                    <Input placeholder="Enter name" className="h-10" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Strength"
                    name="strength"
                    rules={[
                      { required: true, message: "Please enter strength" },
                    ]}
                  >
                    <Input placeholder="Enter strength" className="h-10" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Dose"
                    name="dose"
                    rules={[
                      { required: true, message: "Please enter a dose" },
                    ]}
                  >
                    <Input
                      placeholder="Enter dose"
                      className="h-10"
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Type"
                    name="type"
                    rules={[
                      { required: true, message: "Please select a type" }
                    ]}
                  >
                    <Select
                      placeholder="Type"
                      className="h-10"
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      <Select.Option value="Capsule">Capsule</Select.Option>
                      <Select.Option value="Tablet">Tablet</Select.Option>
                      <Select.Option value="Cream">Cream</Select.Option>
                      <Select.Option value="Syrup">Syrup</Select.Option>
                      <Select.Option value="Drops">Drops</Select.Option>
                      <Select.Option value="Inhalers">Inhalers</Select.Option>
                      <Select.Option value="Injections">Injections</Select.Option>
                      <Select.Option value="Tablets">Tablets</Select.Option>
                      <Select.Option value="Capsules">Capsules</Select.Option>
                      <Select.Option value="Ointmaint">Ointmaint</Select.Option>
                      <Select.Option value="Eye drops">Eye drops</Select.Option>
                      <Select.Option value="Ear drops">Ear drops</Select.Option>
                      <Select.Option value="Sachets">Sachets</Select.Option>
                      <Select.Option value="Spray">Spray</Select.Option>
                      <Select.Option value="Suppsitory">Suppsitory</Select.Option>
                      <Select.Option value="Facial wash">Facial wash</Select.Option>
                      <Select.Option value="Gel">Gel</Select.Option>
                      <Select.Option value="Lotion">Lotion</Select.Option>
                      <Select.Option value="Caplets">Caplets</Select.Option>
                      <Select.Option value="Ampoules">Ampoules</Select.Option>
                      <Select.Option value="Soap">Soap</Select.Option>
                      <Select.Option value="Hair oil">Hair oil</Select.Option>
                      <Select.Option value="Suspention">Suspention</Select.Option>
                      <Select.Option value="Vaginal Suppsitory">Vaginal Suppsitory</Select.Option>
                      <Select.Option value="Vaginal Gel">Vaginal Gel</Select.Option>
                      <Select.Option value="Oral Drops">Oral Drops</Select.Option>
                      <Select.Option value="Shampoo">Shampoo</Select.Option>
                      <Select.Option value="Vial">Vial</Select.Option>
                      <Select.Option value="Infusion">Infusion</Select.Option>
                      <Select.Option value="Cartiridges">Cartiridges</Select.Option>
                      <Select.Option value="Prefilled pen">Prefilled pen</Select.Option>
                      <Select.Option value="Powder">Powder</Select.Option>
                      <Select.Option value="Inhaler">Inhaler</Select.Option>
                      <Select.Option value="Eye OINT">Eye OINT</Select.Option>
                      <Select.Option value="Serum">Serum</Select.Option>
                      <Select.Option value="Mouth wash">Mouth wash</Select.Option>
                      <Select.Option value="Nasal drops">Nasal drops</Select.Option>
                      <Select.Option value="SOLUTION">SOLUTION</Select.Option>
                      <Select.Option value="Vaginal Douch">Vaginal Douch</Select.Option>
                      <Select.Option value="Gummies">Gummies</Select.Option>
                      <Select.Option value="Chewable">Chewable</Select.Option>
                      <Select.Option value="LOZENGES">LOZENGES</Select.Option>
                      <Select.Option value="Effervescent">Effervescent</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Scientific Name"
                    name="scientificName"
                    rules={[
                      { required: true, message: "Please enter scientific name" },
                    ]}
                  >
                    <Input placeholder="Enter scientific name" className="h-10" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Supplier Name"
                    name="supplierName"
                    rules={[
                      { required: true, message: "Please enter supplier name" },
                    ]}
                  >
                    <Input placeholder="Enter supplier name" className="h-10" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Supplier Contact"
                    name="supplierContact"
                    rules={[
                      { required: true, message: "Please enter supplier contact" },
                      {
                        pattern: /^[0-9]{11}$/,
                        message: "Contact must be exactly 11 digits",
                      },
                    ]}
                  >
                    <Input placeholder="Enter supplier contact" className="h-10" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Expiry Date"
                    name="expiryDate"
                    rules={[
                      { required: true, message: "Please select expiry date" },
                    ]}
                  >
                    <DatePicker className="w-full h-10" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Price"
                    name="price"
                    rules={[
                      { required: true, message: "Please enter price" },
                    ]}
                  >
                    <InputNumber
                      placeholder="Enter price"
                      className="w-full h-10"
                      min={0}
                      precision={2}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Stored At"
                    name="storedAt"
                    rules={[
                      { required: true, message: "Please enter storage location" },
                    ]}
                  >
                    <Input placeholder="Enter storage location" className="h-10" />
                  </Form.Item>
                </Col>

                <Col xs={24}>
                  <Form.Item
                    label="Description"
                    name="description"
                    rules={[
                      { required: true, message: "Please enter description" },
                    ]}
                  >
                    <TextArea
                      placeholder="Enter description"
                      rows={4}
                      className="w-full"
                    />
                  </Form.Item>
                </Col>

                <Col xs={24}>
                  <Form.Item
                    label="Side Effects"
                    name="sideEffects"
                    rules={[
                      { required: true, message: "Please enter side effects" },
                    ]}
                  >
                    <TextArea
                      placeholder="Enter side effects"
                      rows={4}
                      className="w-full"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="mt-6">
            <Col xs={24} className="flex flex-col sm:flex-row justify-end space-y-3 sm:space-y-0 sm:space-x-4">
              <Button
                onClick={handleCancel}
                className="h-10 px-6"
              >
                Cancel
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                className="h-10 px-6"
              >
                Add Medicine
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
}

export default AddMedicines;
